import axios from "axios";

const api = axios.create({
  baseURL: '/api',  // 'http://34.129.37.135:5000',
  // credentials: 'include',
  withCredentials: true,
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && error.response?.data?.code === 'token_expired' && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshResponse = await fetch('/api/refresh', {
          method: 'POST',
          credentials: 'include'
        });

        if (refreshResponse.ok) {
          return api(originalRequest);
        }
      } catch (refreshError) {
        console.error('Refresh failed: ', refreshError);
      }
    }
    return Promise.reject(error);
  }
)


export default api;